"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var ModalFooterContainer = _styledComponents.default.div.withConfig({
  displayName: "ModalFooterContainer",
  componentId: "exwym8-0"
})(["width:100%;padding:", ";", " .ui-modal-cancel{padding:0;min-width:0;display:none;", "}.ui-modal-cancel-mobile{display:inherit;", "}"], function (_ref) {
  var theme = _ref.theme;
  return "".concat(theme.spacing.xlarge, " ").concat(theme.spacing.xxxlarge, " ").concat(theme.spacing.xlarge, " ").concat(theme.spacing.xxxlarge);
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.media.medium((0, _styledComponents.css)(["padding:", ";"], function (_ref3) {
    var theme = _ref3.theme;
    return "".concat(theme.spacing.xxlarge);
  }));
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.media.medium((0, _styledComponents.css)(["display:inline-block;"]));
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.media.medium((0, _styledComponents.css)(["display:none;"]));
});

var _default = ModalFooterContainer;
exports.default = _default;
//# sourceMappingURL=ModalFooterContainer.js.map